module.exports = {
  footerText: '© Copyright 2021 English Forward, All Rights Reserved',
}
